import { IDriveItem } from 'services/Graph/SharepointInterfaces';

export const getFullSiteId = (item: IDriveItem | undefined): string | undefined => {
  try {
    if (!item || !item.sharepointIds) {
      return undefined;
    }

    if (item.sharepointIds.siteId && item.sharepointIds.webId && item.sharepointIds.siteUrl) {
      const domain = item.sharepointIds.siteUrl.replace('https://', '').split('/')[0];

      if (domain) {
        return `${domain},${item.sharepointIds.siteId},${item.sharepointIds.webId}`;
      }
    }

    return undefined;
  } catch {
    return undefined;
  }
};
